import { TypographyOptions } from '@mui/material/styles/createTypography';

/**
 * App-UI type scale: fixed rem steps (no fluid clamp in product UI), strong
 * weight contrast, fewer sizes. Hierarchy is carried by weight + size, matching
 * the brand brief ("hierarchy from weight and size contrast, not many sizes").
 * Body stays Nunito Sans — the existing brand face — we only use its full weight
 * range now (300–900) for clearer hierarchy.
 */
export const fontFamily = `'Nunito Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`;

export const typography: TypographyOptions = {
  fontFamily,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontWeight: 800,
    fontSize: '2.25rem',
    lineHeight: 1.15,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontWeight: 800,
    fontSize: '1.75rem',
    lineHeight: 1.2,
    letterSpacing: '-0.015em',
  },
  h3: {
    fontWeight: 700,
    fontSize: '1.375rem',
    lineHeight: 1.25,
    letterSpacing: '-0.01em',
  },
  h4: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    letterSpacing: '-0.005em',
  },
  h5: {
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.4,
  },
  h6: {
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: 1.45,
    letterSpacing: '0.005em',
  },
  subtitle1: {
    fontWeight: 600,
    fontSize: '0.9375rem',
    lineHeight: 1.5,
  },
  subtitle2: {
    fontWeight: 600,
    fontSize: '0.8125rem',
    lineHeight: 1.5,
  },
  body1: {
    fontWeight: 400,
    fontSize: '0.9375rem',
    lineHeight: 1.55,
  },
  body2: {
    fontWeight: 400,
    fontSize: '0.875rem',
    lineHeight: 1.55,
  },
  button: {
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    letterSpacing: 0,
    textTransform: 'none', // kill the dated all-caps button look
  },
  caption: {
    fontWeight: 500,
    fontSize: '0.75rem',
    lineHeight: 1.45,
  },
  overline: {
    fontWeight: 700,
    fontSize: '0.6875rem',
    lineHeight: 1.4,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
};
